import { payrollServiceApi } from "../../app/payrollServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import { GetTaskQueueResponseType } from "../../types/taskQueue";

export const taskQueueApi = payrollServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaskQueues: builder.query<
      GetTaskQueueResponseType,
      GetQueryArgsType<{ page?: number; limit?: number }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTaskQueueList,
        ...queryArgs,
      }),
      providesTags: ["GetTaskQueue"],
    }),
  }),
});

export const { useGetTaskQueuesQuery } = taskQueueApi;
